export default {
  reset_password_title: "Réinitialiser le mot de passe",
  invalid_reset_token: "Le lien de réinitialisation du mot de passe est invalide ou a expiré",
  invalid_reset_token_desc:
    "Le lien de réinitialisation du mot de passe que vous avez fourni est invalide ou a expiré. Veuillez demander un nouveau lien de réinitialisation du mot de passe.",
  password_reset_success: "Votre mot de passe a été réinitialisé avec succès",
  password_reset_success_desc:
    "Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
  reset_password_desc: "Veuillez saisir votre nouveau mot de passe ci-dessous",
  password_required: "Veuillez saisir votre mot de passe",
  password_invalid:
    "Le mot de passe doit comporter au moins 8 caractères et contenir des lettres, des chiffres et des caractères spéciaux",
  password_placeholder: "Saisissez votre mot de passe",
  confirm_password_required: "Veuillez confirmer votre mot de passe",
  passwords_do_not_match: "Les deux mots de passe saisis ne correspondent pas",
  confirm_password_placeholder: "Confirmez le mot de passe",
  reset_password: "Définir un nouveau mot de passe",
  password_same_as_old:
    "Le nouveau mot de passe ne peut pas être identique à l'ancien mot de passe",
  password_reset_failed: "Échec de la réinitialisation du mot de passe",
};
